module.exports = __webpack_public_path__ + "static/media/bear_code_border.eb9c4f50.png";